  <mat-toolbar *ngIf="data.mobileType === 'android'" color="primary" class="android-prompt  m10-orange-bg m10t-default-border-radius">
    <button mat-button (click)="installPwa()">
      Click here to install
    </button>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
  
  <div *ngIf="data.mobileType === 'ios'" class="ios-prompt">
    <button class="close-ios-inv" mat-button color="primary" (click)="close()"><mat-icon>close</mat-icon></button>
    <div>To install this web app on your ios device,open the url in safari, tap the <img class="ios-icon" src="/assets/images/ios_action.png" alt="ios menu icon"> icon and then click 'Add to Home screen' button</div>
  </div>
  
  